/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */

import { useCookies } from 'react-cookie';
import axios from 'axios';
import adminTypes from '../constants/adminTypes';
import useStorage from '../utils/hooks/useStorage';

const API_URL = `https://${process.env.REACT_APP_API_URL}`;

const useApi = () => {
  const { getItem } = useStorage();
  const [cookies, setCookie] = useCookies(['jwt']);

  const axiosConfig = {
    baseURL: API_URL,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const Axios = axios.create(axiosConfig);

  Axios.interceptors.request.use((config) => {
    const jwToken = cookies?.jwt;
    if (jwToken) config.headers['X-Authorization'] = `Bearer ${jwToken}`;

    return config;
  });

  Axios.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalRequest = err.config;

      if (err.response
        && err.response.status === 401
        && err.response.data.code !== 'invalid_credentials'
      ) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;

          const adminType = getItem('adminType');

          try {
            const jwToken = cookies?.jwt;
            const newUserAuth = await axios({
              method: 'post',
              baseURL: API_URL,
              url: `${adminType === adminTypes.platform
                ? '/identity-access/v1/platform-admin-accounts/token'
                : '/identity-access/v1/establishment-admin-accounts/token'}`,
              data: {
                grant_type: 'refresh_token',
              },
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Authorization': `Bearer ${jwToken}`,
              },
            });

            if (newUserAuth?.data?.access_token) {
              const expiryDate = new Date();
              expiryDate.setMonth(expiryDate.getMonth() + 1);

              setCookie(
                'jwt',
                newUserAuth.data.access_token,
                {
                  path: '/',
                  expires: expiryDate,
                  secure: true,
                },
              );

              originalRequest.headers['X-Authorization'] = `Bearer ${newUserAuth.data.access_token}`;

              return Axios(originalRequest);
            }
          } catch (error) {
            if (window.location.pathname !== '/login') window.location.replace('/logout');
          }
        } else {
          window.location.replace('/logout');
        }
      }

      return Promise.reject(err);
    },
  );

  const api = (requestConfig) => Axios(requestConfig);

  return { api };
};

export default useApi;
